import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../../components/common/Modal';
import { useAuth } from '../../contexts/AuthContext'; // FIXED: Proper React import

export default function BranchManagement() {
  const [branches, setBranches] = useState([]);
  const [modal, setModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const { hasPermission } = useAuth(); // FIXED
  
  const [form, setForm] = useState({ branchCode: '', name: '', city: '', phone: '', email: '' });

  useEffect(() => { fetchBranches(); }, []);

  const fetchBranches = () => api.get('/branches').then(res => setBranches(res.data.data));

  const openEdit = (b) => {
    setEditId(b._id);
    setForm({ branchCode: b.branchCode, name: b.name, city: typeof b.address === 'object' ? (b.address?.city || '') : (b.address || ''), phone: b.phone, email: b.email || '' });
    setModal(true);
  };

  const resetForm = () => {
    setEditId(null);
    setForm({ branchCode: '', name: '', city: '', phone: '', email: '' });
    setModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { branchCode: form.branchCode, name: form.name, address: { city: form.city }, phone: form.phone, email: form.email };
    
    try {
      if (editId) await api.put(`/branches/${editId}`, payload);
      else await api.post('/branches', payload);
      resetForm();
      fetchBranches();
    } catch(err) {
      alert(err.response?.data?.message || 'Error saving branch');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this branch? This cannot be undone.')) { 
      await api.delete(`/branches/${id}`); 
      fetchBranches(); 
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <h3>Branch Management</h3>
        {hasPermission('branches', 'create') && <button className="btn btn-primary" onClick={() => { resetForm(); setModal(true); }}>+ Add Branch</button>}
      </div>
      <div className="card">
        <div className="table-container">
          <table>
            <thead><tr><th>Code</th><th>Name</th><th>City</th><th>Phone</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {branches.map(b => (
                <tr key={b._id}>
                  <td>{b.branchCode}</td>
                  <td className="font-bold">{b.name}</td>
                  <td>{b.address?.city}</td>
                  <td>{b.phone}</td>
                  <td><span className={`badge badge-${b.isActive ? 'success' : 'danger'}`}>{b.isActive ? 'Active' : 'Inactive'}</span></td>
                  <td>
                    <div className="flex gap-1">
                      {hasPermission('branches', 'update') && <button className="btn btn-sm btn-outline" onClick={() => openEdit(b)}>Edit</button>}
                      {hasPermission('branches', 'delete') && <button className="btn btn-sm btn-danger" onClick={() => handleDelete(b._id)}>Del</button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal isOpen={modal} onClose={resetForm} title={editId ? "Edit Branch" : "Add Branch"}>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-2 gap-1">
            <div className="form-group"><label>Branch Code*</label><input className="form-control" required value={form.branchCode} onChange={e => setForm({...form, branchCode: e.target.value})} disabled={!!editId} /></div>
            <div className="form-group"><label>Branch Name*</label><input className="form-control" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></div>
          </div>
          <div className="grid grid-2 gap-1">
            <div className="form-group"><label>City*</label><input className="form-control" required value={form.city} onChange={e => setForm({...form, city: e.target.value})} /></div>
            <div className="form-group"><label>Phone*</label><input className="form-control" required value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></div>
          </div>
          <div className="form-group"><label>Email</label><input type="email" className="form-control" value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
          <button type="submit" className="btn btn-primary w-full mt-1">{editId ? 'Update Branch' : 'Create Branch'}</button>
        </form>
      </Modal>
    </div>
  );
}